import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Projectmember } from './model/projectmember';
import { OrgprojectmemberlistService } from './service/orgprojectmemberlist.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgprojectmemberlist',
  templateUrl: './orgprojectmemberlist.component.html',
  styleUrls: ['./orgprojectmemberlist.component.css']
})
export class OrgprojectmemberlistComponent implements OnInit, OnChanges {
  @Output() members:Projectmember[];
  allMembers:Projectmember[];
  @Input() projectId:string;
  @Input() memberToAdd:Projectmember;
  @Input() membersToAdd:Projectmember[];
  memberToDelete:Projectmember;
  modalPerson:Projectmember;
  modalorgId:string;
  showSpinner:boolean;
  showDeleteConfirm:boolean;
  @ViewChild('rolemodalclose',{static:true}) rolemodalclose:ElementRef;

  @ViewChild('deletemodalclose',{static:true}) deletemodalclose:ElementRef;
  constructor(
    private membersrv:OrgprojectmemberlistService,
    private datastore: DatastoreService
    ) { }

  ngOnInit() {
    this.modalPerson= new Projectmember;
    this.memberToDelete = new Projectmember;
    this.showDeleteConfirm = false;
    this.members = [];
    this.modalorgId = SessionHelper.getChoosenOrg();
    this.datastore.projectpersonList$.pipe(untilDestroyed(this)).subscribe(ppl => {
      this.allMembers = ppl;
      this.members = ppl.filter(p => p.projectId == this.projectId);
    
    //this.membersrv.getMembers(this.projectId).pipe(untilDestroyed(this)).subscribe(memberslist => {
      //this.members = memberslist;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    //Add member to list when joiner is accepted. Only look for project id if current value is set.
    if(changes.memberToAdd && changes.memberToAdd.currentValue && changes.memberToAdd.currentValue.projectId == this.projectId){
      this.members.push(changes.memberToAdd.currentValue);
    }
    if(changes.membersToAdd && changes.membersToAdd.currentValue && this.members && changes.membersToAdd.currentValue[0].projectId == this.projectId){
      this.members = this.members.concat(changes.membersToAdd.currentValue);
      
    }
    if(changes.projectId && changes.projectId.currentValue){
      this.members = [];
      //this.membersrv.getMembers(this.projectId).pipe(untilDestroyed(this)).subscribe(memberslist => {
        this.members = this.allMembers.filter(p => p.projectId == this.projectId);
      //});
      
    }
    
  }
  onClick(person:Projectmember){
    this.modalPerson = person;
  }

  setDeleteMember(member:Projectmember){
    this.memberToDelete = member;
    this.showDeleteConfirm = true;
  }
  deleteMember(){
    this.membersrv.deleteMember(this.memberToDelete ).pipe(untilDestroyed(this)).subscribe(p=> { 
      this.deletemodalclose.nativeElement.click();
      //remove from UI
      this.members.splice(this.members.indexOf(this.memberToDelete),1);
      this.memberToDelete = new Projectmember;
    });
  }
  saveRole(){
    this.membersrv.saveMember(this.modalPerson).pipe(untilDestroyed(this)).subscribe(p=> {
      this.modalPerson = new Projectmember;
      this.rolemodalclose.nativeElement.click();
    });
  }
}
